(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/sportsbook/components/sbtech-api-impl/assets/javascripts/requests/sbtech-analytics.js') >= 0) return;  svs.modules.push('/modules/sportsbook/components/sbtech-api-impl/assets/javascripts/requests/sbtech-analytics.js'); "use strict";


const {
  transaction: Transaction,
  transactionItem: TransactionItem,
  trackTransaction
} = svs.components.analytics;
svs.sportsbook.sbtech_api_impl.fns.requests.sbtech_analytics = () => data => {
  if (data && data.event === 'sbtech_analytics.placeBet') {
    const totalCost = data.value;
    const numSelections = data.selections.length;
    const costPerSelection = totalCost / numSelections;
    const items = data.selections.map(s => new TransactionItem('EXTOX', 'Oddset', costPerSelection, 1, {
      system: data.type,
      odds: s.odds,
      isLive: s.isLive,
      event: s.event,
      league: s.league,
      sport: s.sport
    }));
    const transaction = new Transaction(data.id, totalCost, items, 0, 0, undefined, 'Oddset');
    trackTransaction(transaction);
  }
};
 })(window);